import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, map, of } from 'rxjs';

import { PlanService } from '../../plan/plan.service';
import { UserService } from '../../user/user.service';

const FINANCE_URL = '/settings/general/finance';

export const PlanGuard: CanActivateFn | CanActivateChildFn = (
    route,
    state
) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);
    const planService = inject(PlanService);
    const translocoService = inject(TranslocoService);

    const forbidden = (key: string) =>
        router.createUrlTree(['/403'], {
            queryParams: {
                message: translocoService.translate(
                    'admin.settings.general.finance.' + key
                ),
            },
        });
    const toFinance = () =>
        state.url.startsWith(FINANCE_URL) ? true : router.parseUrl(FINANCE_URL);

    if (!userService.planExpired) {
        return true;
    }

    if (userService.isEmployee) {
        return forbidden('expired_employee');
    }

    if (userService.isTrial) {
        return forbidden('expired');
    }

    return planService.options().pipe(
        map((options) =>
            options.periods?.length ? toFinance() : forbidden('expired')
        ),
        catchError(() => of(toFinance()))
    );
};
